(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
    const initAnnouncementCarousel = (carouselEl) => {
      if (!carouselEl) return;
      const intervalVal = carouselEl.getAttribute('data-interval') === 'false' ? false : parseInt(carouselEl.getAttribute('data-interval'));
      
      // Bootstrap 5 initialization
      if (typeof bootstrap !== 'undefined' && bootstrap.Carousel) {
        if (!bootstrap.Carousel.getInstance(carouselEl)) {
          new bootstrap.Carousel(carouselEl, {
            interval: intervalVal,
            ride: intervalVal ? 'carousel' : false,
            pause: 'hover'
          });
        }
      } 
      // Bootstrap 4 initialization
      else if (typeof $ !== 'undefined' && $.fn && $.fn.carousel) {
        $(carouselEl).carousel({
          interval: intervalVal,
          ride: intervalVal ? 'carousel' : false,
          pause: 'hover'
        });
      }
    };

    const initAllAnnouncements = () => {
      document.querySelectorAll('.announcement-bar-wrapper .carousel').forEach(initAnnouncementCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllAnnouncements);
    } else {
      initAllAnnouncements();
    }

    document.addEventListener('shopify:section:load', function(event) {
      const carouselEl = event.target.querySelector('.carousel');
      if (carouselEl) {
        initAnnouncementCarousel(carouselEl);
      }
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-carrusel-mn"] && !Shopify.designMode) return;
  try {
    
  const initSingleCarousel = (carouselEl) => {
    if (!carouselEl) return;

    // Inicialización para Bootstrap 5 (Vanilla JS)
    if (typeof bootstrap !== 'undefined' && bootstrap.Carousel) {
      if (!bootstrap.Carousel.getInstance(carouselEl)) {
        new bootstrap.Carousel(carouselEl, {
          interval: 5000,
          ride: 'carousel',
          pause: 'hover',
        });
      }
    }
    // Inicialización para Bootstrap 4 (jQuery fallback)
    else if (typeof $ !== 'undefined' && $.fn && $.fn.carousel) {
      $(carouselEl).carousel({
        interval: 5000,
        ride: 'carousel',
        pause: 'hover',
      });
    }
  };

  const initAllCarousels = () => {
    document.querySelectorAll('.carousel').forEach(initSingleCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Soporte para recarga dinámica en el Editor de Temas de Shopify
  document.addEventListener('shopify:section:load', function (event) {
    const carouselEl = event.target.querySelector('.carousel');
    if (carouselEl) {
      initSingleCarousel(carouselEl);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
